{
    "FormEngineRedirectWfl": {
        "title": "Redirect",
        "description": "React to events by redirecting to a web page"
    },
    "mask": {
        "FormEngineRedirectWfl": {
            "description": "Description",
            "url": "Url",
            "urlTarget": "Url Target",
            "allowForeignOrigins": "Allow foreign Origins"
        }
    }
}